import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              禁漫天堂在线
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚精品成人漫画，提供海量正版资源与流畅阅读体验，是漫画爱好者的首选在线阅读平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              帮助中心
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                常见问题
              </a>
              <Link to="/article/1" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                访问指南
              </Link>
              <Link to="/article/3" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                使用教程
              </Link>
              <Link to="/article/4" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                会员权益
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span className="whitespace-nowrap">邮箱：support@jmcomic.com</span>
              <span className="whitespace-nowrap">微信：JMComic_Official</span>
              <span className="whitespace-nowrap">微博：@禁漫天堂官方</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2018 - 2026 禁漫天堂在线 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站仅提供信息导航服务，不存储任何漫画内容
          </p>
        </div>
      </div>
    </footer>
  );
}